export const sentenceToKebab = (text: string): string => {
	return text.replace(/ /g, '-').toLowerCase();
};
